import { IncidentModel } from './incident.model';

export class JudgmentIncidentModel extends IncidentModel {
    public incidentJudgmentId = 0;
    public courtId = 0;
    public courtName: string;
    public accidentDate: any;
    public judgmentCreditor: string;
    public attorneyName: string;
    public attorneyPhoneNumber: string;
    public otherCourtDetail: string;
}
